import { useLayoutEffect, useRef, useState } from 'react';
import { uiText } from '../../../i18n';
import type { CircleFormState } from '../../studio/circle/CircleFieldInput';
import { StudioSheet } from '../../studio/StudioSheet';
import { StudioUploadRights } from '../../studio/StudioUploadRights';

/** Загрузка с согласием: без отметки прав файл ждёт в листе «Права на материалы» (как VideoSource). */
export function useConsentUpload(state: CircleFormState) {
  const [waiting, setWaiting] = useState<{ file: File; go(file: File, current: CircleFormState): void } | null>(null);
  // Загрузка идёт уже с отмеченными правами: берём свежее состояние формы, а не снимок на момент выбора файла.
  const latest = useRef(state);
  useLayoutEffect(() => {
    latest.current = state;
  });
  const take = (file: File, go: (file: File, current: CircleFormState) => void) => {
    if (state.rights) go(file, state);
    else setWaiting({ file, go });
  };
  const sheet = waiting && (
    <StudioSheet title="Права на материалы" onClose={() => setWaiting(null)}>
      <h2>{uiText('Права на материалы')}</h2>
      <StudioUploadRights state={state} />
      <button
        type="button"
        className="btn"
        disabled={state.locked || !state.rights}
        onClick={() => {
          const current = waiting;
          setWaiting(null);
          current.go(current.file, latest.current);
        }}
      >
        {uiText('Продолжить загрузку')}
      </button>
    </StudioSheet>
  );
  return { take, sheet };
}
